<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <validation-observer tag="div" class="p-2" #default="{valid}">
                <div class="vx-logo flex justify-items-center items-center mb-2 pt-4">
                  <img src="@/assets/images/logo/logo.png" alt="logo" class="mx-auto" style="max-height: 25px"/>
                </div>

                <div class="vx-card__title mb-8">
                  <h4 class="mb-4 mt-4 grid justify-items-center">Recupere sua senha</h4>
                  <p>Por favor informe seu endereço de email e iremos lhe enviar instruções pare alterar sua senha.</p>
                </div>

                <validation-provider name="Email" rules="required|email" #default="{errors}">
                  <vs-input
                    v-validate="'required|email'"
                    data-vv-validate-on="blur"
                    type="email"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full mb-8"
                  />
                  <label class="text-danger">
                    {{ errors[0] }}
                  </label>
                </validation-provider>

                <div class="flex flex-row gap-2 flex-wrap justify-center mt-1">
                  <div>
                    <b-button
                      :disabled="!valid"
                      variant="primary"
                      @click="sendForgotInstruction"
                    >Recuperar Senha</b-button>
                  </div>
                  <div>
                    <b-button type="border" to="/login">Voltar para Login</b-button>
                  </div>
                </div>

                <recaptcha-notice />

              </validation-observer>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BFormCheckbox, BCardText, BFormInput, BCard, BCardHeader, BCardTitle, BCardSubTitle, BCardBody, BCollapse, VBToggle, VBTogglePlugin
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import RecaptchaNotice from '@/components/RecaptchaNotice.vue'
import recaptchaMixin from '@/mixins/recaptcha'


export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCollapse,
    VBToggle,
    VBTogglePlugin,
    //----
    ValidationProvider,
    ValidationObserver,
    RecaptchaNotice
  },
  mixins: [recaptchaMixin],
  data() {
    return {
      email: ''
    }
  },
  methods: {
    async sendForgotInstruction() {
      // Loading
      this.$vs.loading()

      const recaptchaToken = await this.getRecaptchaToken('forgot_password')

      const payload = {
        email: this.email,
        recaptcha_token: recaptchaToken,
        notify: this.$vs.notify,
        closeAnimation: this.$vs.loading.close
      }
      this.email = ''
      this.$store.dispatch('auth/forgotPassword', payload)
    }
  }
}
</script>
